<!--<beautyapp-input-->
<!--  [ngModel]="companyName"-->
<!--  label="{{ 'წარსადგენი ადგილი' | translate }}"-->
<!--  size="large"-->
<!--&gt;</beautyapp-input>-->

<nz-form-item>
  <nz-form-label [nzSpan]="24" [nzRequired]="true" nzFor="companyName">
    {{ 'მიუთითეთ წარსადგენი დაწესებულის დასახელება და მისამართი' | translate }}
  </nz-form-label>
  <nz-form-control [nzErrorTip]="'აუცილებელია'">
    <input nz-input [(ngModel)]="sendToCompany" />
  </nz-form-control>
</nz-form-item>
<div *nzModalFooter>
  <button nz-button (click)="modalRef.close()">
    {{ 'buttons.close' | translate }}
  </button>
  <button
    nz-button
    nzType="primary"
    [disabled]="!sendToCompany()"
    (click)="downloadForm100()"
  >
    {{ 'buttons.download' | translate }}
  </button>
</div>
